import type { PropfirmOfferOverride } from '@/service/propfirm-offer/propfirm-offer-types';

import { PROPFIRMS } from './propfirms';
import type { Propfirm } from './types';

const sameOffer = (
  o: Pick<PropfirmOfferOverride, 'firmSlug' | 'label'>,
  firmSlug: string,
  label: string,
) => o.firmSlug === firmSlug && o.label === label;

/// Le catalogue embarqué, les chiffres corrigés par un admin posés sur leurs
/// offres.
export function withOfferOverrides(
  firms: readonly Propfirm[],
  overrides: readonly PropfirmOfferOverride[],
): readonly Propfirm[] {
  if (!overrides.length) return firms;
  return firms.map((firm) => ({
    ...firm,
    accounts: firm.accounts.map((offer) => {
      const o = overrides.find((x) => sameOffer(x, firm.slug, offer.label));
      if (!o) return offer;
      const { firmSlug, label, ...figures } = o;
      return { ...offer, ...figures };
    }),
  }));
}

let overrides: readonly PropfirmOfferOverride[] = [];
let catalogue: readonly Propfirm[] = PROPFIRMS;

/// Pose les corrections chargées du serveur et rend le catalogue corrigé.
export function setOfferOverrides(
  next: readonly PropfirmOfferOverride[],
): readonly Propfirm[] {
  overrides = next;
  catalogue = withOfferOverrides(PROPFIRMS, next);
  return catalogue;
}

/// Catalogue en vigueur pour les calculs faits hors des composants (règles
/// préremplies d'un challenge, rentabilité) : l'embarqué tant que les
/// corrections ne sont pas arrivées.
export const propfirmCatalogue = () => catalogue;

/// Correction d'une offre par un admin : les seuls champs corrigés.
export const offerCorrection = (firmSlug: string, label: string) =>
  overrides.find((o) => sameOffer(o, firmSlug, label));
